function AnswerChoices(props) {
  return (
    <div className="answer-choice">
      <div onClick={props.onClick}>{props.answer}</div>
    </div>
  );
}
export default AnswerChoices;
